<template>
  <v-tab-item
    key="discussion"
    class="community-discussion-tab"
    value="discussion"
  >
    <v-row>
      <v-col>
        <v-tabs-items v-model="currentTab">
          <v-tab-item key="discussion-overview" value="discussion-overview">
            <div class="px-3 px-md-0">
              <div class="pa-4 subdued rounded-lg">
                <h2 class="title font-weight-bold pb-2">Discussion</h2>
                <div class="mr-2 my-3">
                  Welcome to the discussion area! Contribute to the discussion
                  below by adding questions or announcements, or commenting on
                  others’ posts. Discussions should be scholarly in nature:
                  please see our
                  <nuxt-link :to="commentingPolicyUrl"
                    >Commenting and Discussion Policy</nuxt-link
                  >
                  for more information.
                </div>
                <v-btn
                  class="research-directions-questions-tile__button primary inverted--text my-2"
                  @click="changeInnerDiscussionTab('create')"
                  >Start a discussion</v-btn
                >
              </div>
            </div>
            <div class="px-3 px-md-0 mt-6">
              <h2
                class="title font-weight-bold pb-2 border-bottom border-thick border-primary"
              >
                Discussions
              </h2>
              <CommunityDiscussionListing :community="community" />
            </div>
          </v-tab-item>

          <v-tab-item key="create" value="create">
            <DiscussionForm
              :community="community"
              :errors="errors"
              :item="item"
              update-action="modifyProposedDiscussion"
              @changeTab="changeInnerDiscussionTab"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-tab-item>
</template>

<script>
import { mapState } from "vuex";

import isUnauthorized from "~/plugins/utilities/isUnauthorized";
import DiscussionForm from "~/components/forms/DiscussionForm";
import CommunityDiscussionListing from "~/components/communities/discussion/CommunityDiscussionListing";

export default {
  name: "CommunityDiscussionTab",
  components: {
    DiscussionForm,
    CommunityDiscussionListing,
  },
  props: {
    community: { type: Object, required: true },
  },
  computed: {
    ...mapState({
      item: (state) => state.proposedDiscussion,
      errors: (state) => state.discussionErrors,
    }),
    currentTab: {
      set(view) {
        this.$router.replace({ query: { ...this.$route.query, view } });
      },
      get() {
        return this.$route.query.view || "discussion-overview";
      },
    },
    commentingPolicyUrl() {
      return `/engage/coe/about-information?show=commenting-and-discussion-policy`;
    },
  },
  methods: {
    changeInnerDiscussionTab(view) {
      const redirectTo = `${this.$route.path}?show=discussion&view=${view}`;

      if (view === "create" && isUnauthorized(this.$store.state.user, "USER")) {
        this.$root.$emit("show-login-options-redirect", redirectTo);
      } else {
        this.$router.push({
          path: redirectTo,
        });
      }
    },
  },
};
</script>

<style lang="scss">
.community-discussion-tab {
  &__button-inverted {
    border: solid 1px var(--v-primary-base);
    background: var(--v-action-inverted) !important;
  }
}
</style>
